export const getTournamentPath = (tournamentId: string, key: string) =>
  `tournaments/${tournamentId}/${key}` as const;
